import { BotType } from "@shared/types";
import {
  INTENT_BOT_TYPES,
  TradingIntent,
  TRADING_INTENTS,
} from "features/onboarding/guided/intent";

/** The trading method a bot type belongs to, for picking its illustration. */
export const methodForBotType = (botType?: BotType): TradingIntent =>
  TRADING_INTENTS.find((intent) => INTENT_BOT_TYPES[intent] === botType) ??
  "dca";
